// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { addCutLengthsButtonStyles } from "@steiner/App/Components/AddCutLengthsButton/AddCutLengthsButton";
import CutIcon from "@steiner/XDL/Icons/CutIcon";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

addCutLengthsButtonStyles.buttonStyles = {
    color: "primary",
    variant: "secondary",
    sizeVariant: "large",
    icon: {
        src: CutIcon,
        position: "left",
    },
    css: css`
        & svg {
            width: 18px;
            height: 18px;
        }
        ${IconWrapper} {
            margin-right: 6px;
            opacity: 0.66;
        }
        ${TypographyStyle} {
            line-height: ${fontConfig.lineHeight.small};
        }
        ${xScreen("lt", "md")} {
            width: 100%;
            margin-bottom: 4px;
        }
    `,
};
